/**
 * SubscribeUserPriceRow
 *
 * Centered row that shows either the "Free subscription" label or the monthly
 * price string + the coins icon. Used inside SubscribeUserSheetContent.
 */
import React from 'react';
import { useTheme } from '@/presentation/contexts/ThemeContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { AssetIcon } from '@/presentation/components/common/icon/AssetIcon';
import { qaAttr } from '@/presentation/utils/qaAttr';

interface SubscribeUserPriceRowProps {
  showCoinsCharge: boolean;
  priceText: string;
}

export const SubscribeUserPriceRow: React.FC<SubscribeUserPriceRowProps> = ({
  showCoinsCharge,
  priceText,
}) => {
  const { theme } = useTheme();
  const responsive = useResponsiveDesign();
  const { l10n } = useLocale();

  const text = !showCoinsCharge
    ? l10n.subscribeUser.freeSubscription
    : l10n.subscribeUser.monthlyPriceLabel.replace('{amount}', priceText);

  return (
    <div
      {...qaAttr({ id: 'subscribe-user-price', value: text })}
      className="flex items-center justify-center"
      style={{ gap: responsive.spacing.xs }}
    >
      <span
        style={{
          color: theme.text.primary,
          fontSize: responsive.font.base,
          fontWeight: responsive.fontWeight.medium,
        }}
      >
        {text}
      </span>
      {showCoinsCharge && (
        <AssetIcon
          path="/assets/images/coins.png"
          width={responsive.icon.small}
          height={responsive.icon.small}
          color={theme.exclusive}
        />
      )}
    </div>
  );
};
